<template>
 <Toolbar class="apptopbar pt-2 pb-2">
            <template #start>

            	<router-link class="menuitem animate_class  pt-0 show_on_mobile_flex mr-4 mt-2 pb-1 "  :to="'/'+$store.state.auth.user.uuid+'/dashboard'">
                    <img class="topbar_logo_mobile " :src="headericon" @click="gotoDashboard">
                    </router-link>

            	<Button  class="p-button-primary p-button-text p-button-sm hide_on_mobile_flex pt-2 pb-1 raised_item menuitemcapital" @click="toggleSidebar" icon="epmty"><span class="material-icons md-22">
				menu
				</span></Button>

				
                <img class="topbar_logo hide_on_mobile_flex" :src="headerlogo"  @click="gotoDashboard">

				<Button  class="p-button-primary p-button-outlined p-button-sm show_on_mobile_flex pt-1 pb-1 mt-0" @click="toggleOffcanvasMenu" icon="epmty"><span class="material-icons md-26">
				menu
				</span></Button>
				 
            	
            	<!--
                <Button label="New" icon="pi pi-plus" class="mr-2" />
                <Button label="Upload" icon="pi pi-upload" class="p-button-success " />
                <i class="pi pi-bars p-toolbar-separator mr-2" />
                <SplitButton label="Save" icon="pi pi-check" :model="items" class="p-button-warning"></SplitButton>-->
            </template>

             



            <template #end>
            	
            	<!--
                <Button type="button"  
                icon="pi pi-question-circle"  
                :label="$store.state.languages.lang_phrases.arama" 
                aria-haspopup="true" 
                aria-controls="overlay_menu" 
                class="p-button-primary p-button-outlined p-button-sm mr-3 px-4 py-2 hide_on_mobile_flex"   
                @click="showSearchModal"/>
                -->
                
                <!--<Dropdown v-model="$store.state.auth.user.preflang_id" :options="$store.state.languages.languages" optionLabel="name" optionValue="id" class=" z-5 mr-3 border-primary p-inputtext-sm py-0 hide_on_mobile_flex"   @change="switchLanguage" />-->

                <Dropdown v-model="$store.state.auth.user.preflang_id" :options="$store.state.languages.languages" optionLabel="code"  optionValue="id" class=" z-5 mr-3 border-primary p-inputtext-sm py-0  uppercase"   @change="switchLanguage" >

                <template #value="slotProps">                
                <div class="uppercase" v-for="language in $store.state.languages.languages" v-show="language.id ==  slotProps.value">{{ language.code }}</div>
                </template>
                <template #option="slotProps">
                <div class="flex align-items-center">
                <div>{{ slotProps.option.name }}</div>
                </div>
                </template>

                </Dropdown>
                
                <template v-if="$store.state.auth.userroles.includes('supplier')">
                    <!-- tickets-->
                    <template v-if="$store.state.tickets.open_tickets_count>0">
                        <Button type="button"  icon="pi pi-info-circle" :label="$store.state.languages.lang_phrases.destek" aria-haspopup="true" aria-controls="overlay_menu" class="p-button-primary p-button-outlined p-button-sm mr-3 px-4 py-2 hide_on_mobile_flex"   @click="showTicketModal" badgeClass="p-badge-danger" :badge="$store.state.tickets.open_tickets_count.toString()"/>

                         <Button type="button"  icon="pi pi-info-circle"  aria-haspopup="true" aria-controls="overlay_menu" class="p-button-primary p-button-outlined p-button-sm mr-3 px-4 py-2 show_on_mobile_flex"   @click="showTicketModal" badgeClass="p-badge-danger" :badge="$store.state.tickets.open_tickets_count.toString()"/>

                    </template>
                    <template v-else>
                        <Button type="button"  icon="pi pi-info-circle" :label="$store.state.languages.lang_phrases.destek" aria-haspopup="true" aria-controls="overlay_menu" class="p-button-primary p-button-outlined p-button-sm mr-3 px-3 py-2 hide_on_mobile_flex"   @click="showTicketModal" />

                        <Button type="button"  icon="pi pi-info-circle"  aria-haspopup="true" aria-controls="overlay_menu" class="p-button-primary p-button-outlined p-button-sm mr-3 px-3 py-2 show_on_mobile_flex"   @click="showTicketModal" />
                    </template>
                    <!-- tickets-->
                    <!-- notifications-->
                    <template v-if="$store.state.auth.suppliernotifications>0">
                        <Button type="button"  icon="pi pi-comment"  :label="$store.state.languages.lang_phrases.bildirimler" aria-haspopup="true" aria-controls="overlay_menu" class="p-button-primary p-button-outlined p-button-sm mr-3 px-4 py-2 hide_on_mobile_flex"   @click="showNotificationsModal" badgeClass="p-badge-danger" :badge="$store.state.auth.suppliernotifications.toString()"/>

                        <Button type="button"  icon="pi pi-comment"  aria-haspopup="true" aria-controls="overlay_menu" class="p-button-primary p-button-outlined p-button-sm mr-3 px-4 py-2 show_on_mobile_flex"   @click="showNotificationsModal" badgeClass="p-badge-danger" :badge="$store.state.auth.suppliernotifications.toString()"/>
                    </template>
                    <template v-else>
                        <Button type="button"  icon="pi pi-comment"  :label="$store.state.languages.lang_phrases.bildirimler" aria-haspopup="true" aria-controls="overlay_menu" class="p-button-primary p-button-outlined p-button-sm mr-3 px-3 py-2 hide_on_mobile_flex"   @click="showNotificationsModal" />
                        <Button type="button"  icon="pi pi-comment"  aria-haspopup="true" aria-controls="overlay_menu" class="p-button-primary p-button-outlined p-button-sm mr-3 px-3 py-2 show_on_mobile_flex"   @click="showNotificationsModal" />
                    </template>

                    <!-- notifications-->


                     
                </template>
            
                

                <!--
                <UserLanguageSwitcher title="title" :value="$store.state.auth.user.preflang_id" :options="$store.state.languages.languages" valkey="type" @dataChanged="switchLanguage"  />-->

                <Button type="button"  icon="pi pi-user" @click="toggle($event,'userdropdown')" aria-haspopup="true" aria-controls="overlay_menu" class="p-button-primary p-button-outlined p-button-sm mr-2 px-3 py-2"   />                
                <UserDropDown ref="userdropdown"></UserDropDown>
        		<!--<Menu id="overlay_menu" ref="menu" :model="items" :popup="true" />-->
            </template>
        </Toolbar>
</template>

<script>
import UserLanguageSwitcher from "./UserLanguageSwitcher"
export default {

  name: 'Topbar',
  components:{UserLanguageSwitcher},
  data () {
    return {
    	search:null,
        headerlogo:require('../../assets/verify_logo.png'),
        headericon:require('../../assets/verify_icon.svg'),
    	items: [
                {
                    label:this.$store.state.auth.user.name,
                    items:[
						{
							separator: true,
							label:"separator"
						},
						{
						label: 'Profil',
							icon: 'pi pi-user',
							class:"test"
						},
						{
							label: 'Bildirimler',
							icon: 'pi pi-bell'
						}, 
                    ]
                },
                {
                    separator: true,
                    label:"separator"
                },
                {
                    label: 'Çıkış',
                    icon: 'pi pi-power-off',
                    command: () => {
                       this.logout()
                    }
                },
            ]
    }
  },
  methods:{
    showTicketModal()
    {
        console.log("show")
        this.$store.dispatch('ui/setShowTicketModal',true)
    },
    showNotificationsModal()
    {
        this.$store.dispatch('ui/setShowNotificationsModal',true)
    },
    showSearchModal()
    {
        this.$store.dispatch('ui/setShowSearchModal',true)
    },
    switchLanguage(event)
    {
        console.log(event.value);
        let formdata = new FormData()      
        this.silentSubmission(formdata,"user/set_pref_lang/"+event.value,this.afterswitchLanguage)
    },
    afterswitchLanguage(response)
    {
        this.getUserData()
    },
  	 toggle(event,name) {
        //this.$refs.menu.toggle(event);
        this.$refs[name].showPanel()
    },
    gotoDashboard()
    {
        this.$router.push({ name: 'Dashboard' })
    },
    toggleSidebar()
    {
    	if(this.$store.state.ui.menuopen)
  		{
  			this.$store.dispatch('ui/setMenuOpen',false)
  		}
  		else{
  			this.$store.dispatch('ui/setMenuOpen',true)
  		}
    },
    toggleOffcanvasMenu()
    {
    	this.$store.dispatch('ui/setOffcanvasMenu',true)
    },
    openNotifications()
    {
        console.log("openNotifications");
        this.$store.dispatch('ui/setNotifications',true)
    },
    
    openSearchArea()
    {
        console.log("openSearchArea");
        this.$store.dispatch('ui/setShowSearchArea',true)
    },
    
    async logout()
  	{
  		 let formdata = new FormData()      
      this.generalSubmission(formdata,"logout",this.afterLogout)
  	},
  	afterLogout(response)
  	{
  		console.log(response.data)
  		localStorage.removeItem("vrf_token");
  		this.$router.push({ path: '/login' })

  	}
  }
}
</script>

<style lang="css" scoped>
</style>